import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { hasValue } from 'globalutils/fmUtils';
import { schema } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const CompanyInfoForm = ({ apiStatus, clearApiStatus, addCompanyInfo, states, getCompanyInfoApi, addTruck }) => {
  const hasApiStatus = hasValue(apiStatus.status, 'api', 'addCompany');

  const handleSubmit = (fields) => {
    if (getCompanyInfoApi?.companyId) {
      fields.companyId = getCompanyInfoApi?.companyId;
    }
    fields.state = fields.state.value;
    addCompanyInfo({
      id: 'addCompany',
      data: fields,
    });
  };

  return (
    <div>
      <div className="formLogin forgotPassword">
        <Form
          type="server"
          direction="column"
          initialValues={{
            companyName: getCompanyInfoApi?.companyName ? getCompanyInfoApi.companyName : '',
            address: getCompanyInfoApi?.address ? getCompanyInfoApi.address : '',
            state: getCompanyInfoApi?.state
              ? {
                  label: getCompanyInfoApi?.state,
                  value: getCompanyInfoApi?.state,
                }
              : '',
            city: getCompanyInfoApi?.city ? getCompanyInfoApi.city : '',
            zipCode: getCompanyInfoApi?.zipCode ? getCompanyInfoApi.zipCode : '',
            companyPhone: getCompanyInfoApi?.companyPhone ? getCompanyInfoApi.companyPhone : '',
            dotNumber: getCompanyInfoApi?.dotNumber ? getCompanyInfoApi.dotNumber : '',
            initialTrucks: getCompanyInfoApi?.initialTrucks ? getCompanyInfoApi.initialTrucks : '',
          }}
          RenderComponent={RenderComponent}
          handleOnSubmit={handleSubmit}
          customProps={{
            hasApiStatus,
            clearApiStatus,
            states,
            addTruck,
          }}
          validationSchema={schema}
        />
      </div>
    </div>
  );
};

export default CompanyInfoForm;

CompanyInfoForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  callback: PropTypes.func,
  clearApiStatus: PropTypes.func.isRequired,
};
